<template>
  <div class="card-body">
    <table class="table table-sm price-table">
      <tbody>
      <tr>
        <th>{{ $t('order.total_product') }}</th>
        <td>{{ order.total_product | currency(order.currency) }}</td>
      </tr>
      <tr>
        <th>{{ $t('order.local_shipping_fee') }}</th>
        <td>{{ order.local_shipping_fee | currency(order.currency) }}</td>
      </tr>
      <tr v-if="order.overseas_shipping_fee">
        <th>{{ $t('order.overseas_shipping_fee') }}</th>
        <td>{{ order.overseas_shipping_fee | currency(order.currency) }}</td>
      </tr>
      <tr v-if="order.handling_fee">
        <th>{{ $t('order.handling_fee') }}</th>
        <td>{{ order.handling_fee | currency(order.currency) }}</td>
      </tr>
      <tr v-if="order.total_sale_tax">
        <th>{{ $t('order.sale_tax') }}</th>
        <td>{{ order.total_sale_tax | currency(order.currency) }}</td>
      </tr>
      <tr v-if="order.total_import_tax">
        <th>{{ $t('order.import_tax') }}</th>
        <td>{{ order.total_import_tax | currency(order.currency) }}</td>
      </tr>
      <tr>
        <th>{{ $t('order.total_price') }}</th>
        <td>
          <section v-if="order.discount_price !== order.total_price" :class="{ 'price-has-discount': order.discount_price }">
            {{ order.total_price | currency(order.currency) }}
          </section>
          <section class="discount-price" v-if="order.discount_price">
            {{ order.discount_price | currency(order.currency) }}
          </section>
        </td>
      </tr>
      </tbody>
    </table>
  </div>
</template>
<script>

  export default {
    name: 'OrderItemCard',
    props: {
      order: {
        required: true,
        type: Object,
      },
    },
  };
</script>
